import { NgModule,APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { PipesModule } from './pipes.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomInterceptor } from './services/custom-interceptor.service';
import { ApigeeService } from './services/apigee.service';
import { MatDialogModule } from '@angular/material/dialog';
import { NotificationService } from './services/notification.service';
import { AppConfigService } from './services/app-config.service';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PipesModule,
    HttpClientModule,
    MatDialogModule
  ],
  providers: [
    AppConfigService,
    ApigeeService,
    NotificationService,
    {provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'fill'}},
    {
      provide:APP_INITIALIZER,
      useFactory: (apigeeService: ApigeeService, appConfigService: AppConfigService) => {
        return () => {
          return appConfigService.loadConfig(environment.env).then(() => {
            return apigeeService.tokenApigeeObs().subscribe(resp => {
              apigeeService.token.next(resp.access_token);
            });
          });
        }
      },
      multi: true,
      deps: [ApigeeService,AppConfigService]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
